import React from 'react'
import intl from 'react-intl-universal'
import { connect } from 'react-redux'
import { Modal, ModalBody, ModalFooter, Button } from 'reactstrap'

// eslint-disable-next-line @typescript-eslint/no-var-requires
import styles from './TypographPluginModal.module.scss'

interface Props {
  toggle: () => void
  handleDisableTypographClick: () => void
  handleCloseTypographPluginModal: () => void
}

function TypographPluginModal(props: Props) {
  return (
    <Modal
      wrapClassName="bootstrap4"
      className={styles.root}
      centered
      isOpen
      toggle={props.toggle}
      data-testid="settings-create/update-annotations-modal"
    >
      <ModalBody>
        <h4 className="title">
          {intl.get('settings.plugins.typograph.modal.title')}
        </h4>
        <p>{intl.get('settings.plugins.typograph.modal.content')}</p>
        <p>{intl.get('settings.plugins.typograph.modal.content.question')}</p>
      </ModalBody>
      <ModalFooter className="footer">
        <Button
          outline
          color="secondary"
          onClick={props.handleCloseTypographPluginModal}
          data-testid="settings-typograph-modal-cancel-btn"
        >
          {intl.get('settings.plugins.typograph.modal.cancel.btn')}
        </Button>
        <Button
          color="danger"
          onClick={props.handleDisableTypographClick}
          className="d-flex align-items-center justify-content-center"
          data-testid="settings-typograph-modal-disable-btn"
        >
          {intl.get('settings.plugins.typograph.modal.disable.btn')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default connect()(TypographPluginModal)
